module.exports = __webpack_public_path__ + "static/img/button-check.5e697f91.svg";